/**
 * Copyright (c) Formium, Inc. and its affiliates.
 *
 * This source code is licensed under the Business Source License license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
/**
 *
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 *
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { CustomerAccess } from './CustomerAccess';
import { ProjectAccess } from './ProjectAccess';
import { ProviderIdentity } from './ProviderIdentity';
/* eslint-disable @typescript-eslint/consistent-type-assertions */

/**
 * User
 *
 * @public
 */
export interface User {
  /**
   * globally unique id of user
   */
  id: string;

  /**
   * full name of user
   */
  name: string;

  /**
   * unique email of user
   */
  email: string;

  /**
   * URL of the users avatar
   */
  avatarUrl?: string;

  /**
   * status
   */
  status: UserStatus;

  /**
   * set of projects that this user has access to
   */
  projects: Array<ProjectAccess>;

  /**
   * set of customers that this user has access to (should always include any customers covered by projects)
   */
  customers: Array<CustomerAccess>;

  /**
   * set of third party identities for the user
   */
  identities?: Array<ProviderIdentity>;

  /**
   * created timestamp
   */
  createAt: string;

  /**
   * created by user id
   */
  createId: string;

  /**
   * created timestamp
   */
  updateAt: string;

  /**
   * updated by user id
   */
  updateId: string;

  /**
   * deleted timestamp
   */
  deleteAt?: string;

  /**
   * deleted by user id
   */
  deleteId?: string;
}

export enum UserStatus {
  ACTIVE = <any>'ACTIVE',
  INACTIVE = <any>'INACTIVE',
}
